import ProgressBar from "@ramonak/react-progress-bar";
import { Row, Col } from "antd";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   BarElement,
   Title,
   Tooltip,
   Legend,
} from 'chart.js';
import { Bar } from "react-chartjs-2";
import Utils from "./Utils";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const renderPartLabel = (title) => {
   return (
      <tr>
         <td style={{ width: '12.6pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong>&nbsp;</strong></p>
         </td>
         <td style={{ width: '382.3pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt', textAlign: 'left' }}><strong>{title}</strong></p>
         </td>
         <td style={{ width: '31.7pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>&nbsp;</p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>&nbsp;</p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>&nbsp;</p>
         </td>
      </tr>
   );
}

const generateMeandLevelHeader = () => {
   return (
      <tr style={{textAlign: 'center'}}>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Area</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>VN</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Pre Test Mean</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Post Test Mean</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Minimum</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Maximum</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Standard Deviation</span></strong>
         </td>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
            <strong><span style={{ color: '#ffffff' }}>Proficiency Level</span></strong>
         </td>
      </tr>
   );
}


const generateMeanLevelRow = (label, data, istotal) => {
   return (
      <tr>
         <td style={{ width: '29%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong>{label}</strong></p>
         </td>
         <td style={{ width: '4%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.vn}</p>
         </td>
         <td style={{ width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.prem <= 0 || data.prem === null ? '' : (data.prem).toFixed(2)}</p>
         </td>
         <td style={{ width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.postm <= 0 || data.postm === null ? '' : (data.postm).toFixed(2)}</p>
         </td>
         <td style={{ width: '10%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.min}</p>
         </td>
         <td style={{ width: '9%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.max}</p>
         </td>
         <td style={{ width: '9%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{(data.sd).toFixed(2)}</p>
         </td>
         <td style={{ width: '16%', borderStyle: 'solid', borderWidth: '0.75pt', borderTop: '1pt solid #000000', paddingRight: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.proficiency}</p>
         </td>
      </tr>
   );
}

const renderCompetencyRow = (idx, label, answer, pre_percent, post_percent, index) => {
   var pre = pre_percent !== undefined ? pre_percent[`percent_correct_s${index}`] : null;
   var post = post_percent !== undefined ? post_percent[`percent_correct_s${index}`] : null;

   return (
      <tr>
         <td style={{ width: '12.6pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong>{idx}</strong></p>
         </td>
         <td style={{ width: '382.3pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt', textAlign: 'left' }}>{label}</p>
         </td>
         <td style={{ width: '31.7pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{answer[`s${index}`] === 1 || answer[`s${index}`] === '1' ? <CheckOutlined style={{ fontSize: '22px', color: '#52c41a' }} /> : <CloseOutlined style={{ fontSize: '22px', color: '#eb2f96' }} />}</p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  pre &&
                  <>
                     <span>{pre.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={pre}
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>
               }

            </p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  post &&
                  <>
                     <span>{post.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={post}
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>
               }
            </p>
         </td>
      </tr>
   );
}

const renderCompetencyRowV2 = (label, answer, data, index) => {
   var preData = data.Pre[0];
   var postData = data.Post[0];

   var pre = preData !== undefined ? preData[`percent_correct_s${index}`] : null;
   var post = postData !== undefined ? postData[`percent_correct_s${index}`] : null;

   return (
      <tr>
         <td style={{ width: '12.6pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong>{index}</strong></p>
         </td>
         <td style={{ width: '382.3pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt', textAlign: 'left' }}>{label}</p>
         </td>
         <td style={{ width: '31.7pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{answer[`s${index}`] === 1 || answer[`s${index}`] === '1' ? <CheckOutlined style={{ fontSize: '22px', color: '#52c41a' }} /> : <CloseOutlined style={{ fontSize: '22px', color: '#eb2f96' }} />}</p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  pre &&
                  <>
                     <span>{pre.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={pre}
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>
               }

            </p>
         </td>
         <td style={{ width: '81pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  post &&
                  <>
                     <span>{post.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={post}
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>
               }
            </p>
         </td>
      </tr>
   );
}

const renderSummaryRow = (label, raw_score, item_count, s1, s2) => {
   return (
      <tr>
         <td style={{ width: '197.1pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}><strong>{label}</strong></p>
         </td>
         <td style={{ width: '79.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {raw_score}
            </p>
         </td>
         <td style={{ width: '61.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {(((raw_score) / item_count) * 100).toFixed(2)}%
            </p>
         </td>
         <td style={{ width: '59.9pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {((raw_score - s1) / s2).toFixed(2)}
            </p>
         </td>
         <td style={{ width: '99.4pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {((raw_score - s1) / s2) > 1 ? 'Competent' : (((raw_score - s1) / s2) >= -0.51 ? 'Basic' : (((raw_score - s1) / s2) > -10 ? 'Beginner' : ''))}
            </p>
         </td>
      </tr>
   );
}

const generateFrequencyRow = (label, data, index) => {
   return (
      <>
         <p style={{ marginTop: '0pt', marginBottom: '10pt', lineHeight: '115%', fontSize: '12pt' }}><strong>&nbsp;</strong></p>
         <p style={{ marginTop: '0pt', marginBottom: '0pt' }}><strong>{index}. Frequency of Proficiency Levels in {label}</strong></p>
         <table cellSpacing={0} cellPadding={0} style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
               <tr>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'top', backgroundColor: '#000000' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>&nbsp;</span></strong></p>
                  </td>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'top', backgroundColor: '#000000' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Count</span></strong></p>
                  </td>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'top', backgroundColor: '#000000' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Percent</span></strong></p>
                  </td>
               </tr>
               <tr>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeftStyle: 'solid', borderLeftWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '4.9pt', verticalAlign: 'top' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Beginner</strong></p>
                  </td>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data?.beginner}</p>
                  </td>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'beginner')}</p>
                  </td>
               </tr>
               <tr>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'top' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Basic&nbsp;</strong></p>
                  </td>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data?.basic}</p>
                  </td>
                  <td style={{ border: '0.75pt solid #bfbfbf', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'basic')}</p>
                  </td>
               </tr>
               <tr>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeftStyle: 'solid', borderLeftWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '4.9pt', verticalAlign: 'top' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Competent&nbsp;</strong></p>
                  </td>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data?.competent}</p>
                  </td>
                  <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                     <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'competent')}</p>
                  </td>
               </tr>
            </tbody>
         </table>
      </>
   );
}

const generatePercentCorrectRow = (label, predata, postdata, index) => {
   return (
      <tr>
         <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeftStyle: 'solid', borderLeftWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>{index}</strong></p>
         </td>
         <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>{label}</p>
         </td>
         <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRight: '0.75pt solid #bfbfbf', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{predata !== null ? predata.toFixed(2) + '%' : ''}</p>
         </td>
         <td style={{ borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderLeft: '0.75pt solid #bfbfbf', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '10pt' }}>{postdata !== null ? postdata.toFixed(2) + '%' : ''}</p>
         </td>
      </tr>
   );
}

const generatePercentCorrectForLevel = (label, data, percent_correct, index) => {
      return (
         <tr>
            <td style={{ width: '11.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderLeftStyle: 'solid', borderLeftWidth: '0.75pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
                  <strong>{index}</strong>
               </p>
            </td>
            <td style={{ width: '330.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
                  {label}
               </p>
            </td>
            <td style={{ width: '43.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {data}
               </p>
            </td>
            <td style={{ width: '75.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {percent_correct}%
               </p>
            </td>
         </tr>
      );
   }

const generateContentStandards = (label, beg1, beg2, bas1, bas2, comp1, comp2) => {
   return (
      <tr style={{ height: '14.5pt' }}>
         <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', lineHeight: '115%', fontSize: '12pt' }}><strong>{label}</strong></p>
         </td>
         <td style={{ width: '4.54%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{beg1}</p>
         </td>
         <td style={{ width: '3.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>-</p>
         </td>
         <td style={{ width: '9.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{beg2}</p>
         </td>
         <td style={{ width: '9.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{bas1}</p>
         </td>
         <td style={{ width: '3.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>-</p>
         </td>
         <td style={{ width: '9.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{bas2}</p>
         </td>
         <td style={{ width: '8.42%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{comp1}</p>
         </td>
         <td style={{ width: '3.94%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>-</p>
         </td>
         <td style={{ width: '6.1%', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ textAlign: 'center', marginBottom: '0pt' }}>{comp2}</p>
         </td>
      </tr>
   );
}

const generateMTFrequencyRow = (label, data, index) => {
   return (
      <>
         <Row style={{marginTop: 25}}>
            <Col span={24} style={{ textAlign: "left" }}><p style={{ marginTop: '0pt', marginBottom: '0pt' }}><strong>{index}. {label !== "TOTAL" ? "Frequency of Proficiency Levels on " : ""} {label}</strong></p></Col>
         </Row>
         <Row>
            <Col span={12}>
               <table cellSpacing={0} cellPadding={0} style={{ width: '100%', border: '0.75pt solid #cccccc', borderCollapse: 'collapse' }}>
                  <tr>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Proficiency</span></strong></p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Count</span></strong></p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle', backgroundColor: '#4F81BD' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong><span style={{ color: '#ffffff' }}>Percent</span></strong></p>
                     </td>
                  </tr>
                  <tr>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Beginner</strong></p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.beginner}</p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'beginner') === '100.00' ? '100' : (Utils.getPercentage(data, 'beginner') === '0.00' ? '0' : Utils.getPercentage(data, 'beginner'))}</p>
                     </td>
                  </tr>
                  <tr>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Basic&nbsp;</strong></p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.basic}</p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'basic') === '100.00' ? '100' : (Utils.getPercentage(data, 'basic') === '0.00' ? '0' : Utils.getPercentage(data, 'basic'))}</p>
                     </td>
                  </tr>
                  <tr>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '4.9pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}><strong>Competent&nbsp;</strong></p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.03pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{data.competent}</p>
                     </td>
                     <td style={{ borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '4.9pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
                        <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>{Utils.getPercentage(data, 'competent') === '100.00' ? '100' : (Utils.getPercentage(data, 'competent') === '0.00' ? '0' : Utils.getPercentage(data, 'competent'))}</p>
                     </td>
                  </tr>
               </table>
            </Col>
            <Col span={12}>
               <div style={{ marginLeft: "20px", marginRight: "20px", height: "200px" }}>
                  <Bar
                     options={{
                        responsive: true,
                        scales: {
                           y:
                           {
                              min: 0,
                              max: 100,
                              stepSize: 1,
                           },
                           x:
                              {},
                        }
                     }}

                     data={{
                        labels: ['Beginner', 'Basic', 'Competent'],
                        datasets: [
                           {
                              label: label,                              
                              data: [Utils.getPercentage(data, 'beginner'), Utils.getPercentage(data, 'basic'), Utils.getPercentage(data, 'competent')],
                              backgroundColor: "#4F81BD",
                              borderColor: "#4F81BD",
                              // backgroundColor: [
                              //    "#ef4444", // Red
                              //    "#f59e0b", // Amber
                              //    "#22c55e" // Green
                              //    ],
                              // borderColor: [
                              //    "#dc2626",                                    
                              //    "#d97706",
                              //    "#16a34a"                                 
                              //    ],
                              // borderWidth: 1,
                           },
                        ],
                     }}
                  />
               </div>
            </Col>
         </Row>
      </>
   );
}

const generateMTPercentCorrectRowV2 = (label, data, index) => {
   var pre = data[`pre_s${index}`] !== undefined ? data[`pre_s${index}`] : null;
   var post = data[`post_s${index}`] !== undefined ? data[`post_s${index}`] : null;

   return (
      <tr>
         <td style={{ width: '11.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderLeftStyle: 'solid', borderLeftWidth: '0.75pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               <strong>{index}</strong>
            </p>
         </td>
         <td style={{ width: '330.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               {label}
            </p>
         </td>
         <td style={{ width: '43.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (pre !== null) &&
                  <>
                     <span>{pre.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={pre}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
         <td style={{ width: '75.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (post !== null) &&
                  <>
                     <span>{post.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={post}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
      </tr>
   );
}

const generateMTPercentCorrectRow = (label, predata, postdata, index) => {
   return (
      <tr>
         <td style={{ width: '11.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderLeftStyle: 'solid', borderLeftWidth: '0.75pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               <strong>{index}</strong>
            </p>
         </td>
         <td style={{ width: '330.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               {label}
            </p>
         </td>
         <td style={{ width: '43.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (predata !== null) &&
                  <>
                     <span>{predata.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={predata}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
         <td style={{ width: '75.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (postdata !== null) &&
                  <>
                     <span>{postdata.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={postdata}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
      </tr>
   );
}

const generateMTPercentCorrectRow2 = (label, data, index) => {
   var pre = data[`pre_s${index}`] !== undefined ? data[`pre_s${index}`] : null;
   var post = data[`post_s${index}`] !== undefined ? data[`post_s${index}`] : null;

   return (
      <tr>
         <td style={{ width: '11.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderLeftStyle: 'solid', borderLeftWidth: '0.75pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               <strong>{index}</strong>
            </p>
         </td>
         <td style={{ width: '330.2pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
               {label}
            </p>
         </td>
         <td style={{ width: '43.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (pre !== null) &&
                  <>
                     <span>{pre.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={pre}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
         <td style={{ width: '75.35pt', borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'middle' }}>
            <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
               {
                  (post !== null) &&
                  <>
                     <span>{post.toFixed(1) + "%"}</span>
                     <ProgressBar
                        borderRadius="3px"
                        bgColor="#4F81BD"
                        completed={post}
                        labelSize="12px"
                        animateOnRender
                        isLabelVisible={false}
                     />
                  </>

               }
            </p>
         </td>
      </tr>
   );
}

const renderLabel = (label) => {
   return (
      <>
         <tr>
            <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '5.03pt', verticalAlign: 'middle' }}>
               <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
                  <strong>{label}</strong>
               </p>
            </td>
         </tr>
      </>
   );
}

// Sub-competency labels (e.g. A-1, A-2, ...) are headings that group several item
// level competencies. They do not carry an item index or score, so they render as
// an indented heading row that spans the full width of the competency table.
const renderSubLabel = (label) => {
   return (
      <tr>
         <td colSpan={4} style={{ width: '11.2pt', borderStyle: 'solid', borderWidth: '0.75pt', paddingRight: '5.4pt', paddingLeft: '14pt', verticalAlign: 'middle' }}>
            <p style={{ margin: '0pt 5.65pt', textAlign: 'left', fontSize: '11pt' }}>
               <em><strong>{label}</strong></em>
            </p>
         </td>
      </tr>
   );
}

function sumDataRange(data, length, index) {
   return data ? Array.from({ length }, (_, i) => data[`s${i + index}`] ?? 0).reduce((sum, val) => sum + val, 0) : 0;
}

function getSS1(val1, val2, val3) {
   var retVal = '';

   if (((val1 - val2) / val3) > 1)
      retVal = 'Competent';
   else {
      if (((val1 - val2) / val3) >= -1)
         retVal = 'Basic';
      else if (((val1 - val2) / val3) > -10)
         retVal = 'Beginner';
      else
         retVal = '';
   }

   return retVal;
}

function getSS(val1, val2, val3) {
   var retVal = '';

   if (((val1 - val2) / val3) > 1)
      retVal = 'Competent';
   else {
      if (((val1 - val2) / val3) >= -0.51)
         retVal = 'Basic';
      else if (((val1 - val2) / val3) < -0.51)
         retVal = 'Beginner';
      else
         retVal = '';
   }

   return retVal;
}

const renderSummaryResult = (label, competency, itemcount, val1, val2, subject) => {
   return (
      <>
         <tr>
            <td style={{ width: '35.76%', borderTopStyle: 'solid', borderTopWidth: '1pt', borderLeftStyle: 'solid', borderLeftWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '4.9pt', verticalAlign: 'top' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', fontSize: '11pt' }}>
                  <strong>{label}</strong>
               </p>
            </td>
            <td style={{ width: '15.16%', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'top' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {competency}
               </p>
            </td>
            <td style={{ width: '14.04%', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'top' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {
                     (((competency) / itemcount) * 100).toFixed(2)
                  }%
               </p>
            </td>
            <td style={{ width: '14.58%', borderTopStyle: 'solid', borderTopWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '5.4pt', paddingLeft: '5.4pt', verticalAlign: 'top' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {
                     ((competency - val1) / val2).toFixed(2)
                  }
               </p>
            </td>
            <td style={{ width: '20.46%', borderTopStyle: 'solid', borderTopWidth: '1pt', borderRightStyle: 'solid', borderRightWidth: '1pt', borderBottomStyle: 'solid', borderBottomWidth: '1pt', paddingRight: '4.9pt', paddingLeft: '5.4pt', verticalAlign: 'top' }}>
               <p style={{ marginTop: '0pt', marginBottom: '0pt', textAlign: 'center', fontSize: '11pt' }}>
                  {
                     getSS(competency, val1, val2)
                  }
               </p>
            </td>
         </tr>
      </>
   );
}

const modules = {
   renderPartLabel,
   generateMeanLevelRow,
   renderCompetencyRow,
   renderSummaryRow,
   generateFrequencyRow,
   generatePercentCorrectRow,
   generateContentStandards,
   generateMTFrequencyRow,
   generateMTPercentCorrectRow,
   generateMTPercentCorrectRow2,
   renderLabel,
   sumDataRange,
   renderCompetencyRowV2,
   generateMTPercentCorrectRowV2,
   generateMeandLevelHeader,
   getSS,
   renderSummaryResult,
   generatePercentCorrectForLevel,
   renderSubLabel
}

export default modules;
